import React from "react";
import Modal from "react-bootstrap/Modal";
import Input from "../common/input";

const DependencyModal = ({
  show,
  data,
  errors,
  handleHide,
  handleChange,
  handleSubmit
}) => {
  return (
    <Modal show={show} onHide={handleHide}>
      <Modal.Header closeButton className="bg-success text-white">
        <Modal.Title>Add Dependency</Modal.Title>
      </Modal.Header>
      <form>
        <Modal.Body>
          <div className="form-row">
            <div className="col">
              <Input
                name="SEQUENCE"
                label="Sequence Number"
                placeholder="Value"
                value={data.SEQUENCE}
                onChange={handleChange}
                error={errors.SEQUENCE}
              />
            </div>
            <div className="col">
              <Input
                name="DEPENDENT"
                label="Parameter Code"
                placeholder="Dependency"
                value={data.DEPENDENT}
                onChange={handleChange}
                error={errors.DEPENDENT}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={handleSubmit}>
            Save
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default DependencyModal;
